"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter as useAppRouter, useParams, usePathname, useSearchParams } from "next/navigation";
import { startTransition, useCallback, useMemo } from "react";
import { parsePlaygroundPathname } from "#/shared/lib/playgroundRoute";
export type PlaygroundNavigateOptions = {
  /** @default false */
  replace?: boolean;
  /** Drop `view` from the next URL. */
  omitView?: boolean;
};
export type PlaygroundRouteContext = {
  basePath: string;
  slug: string[];
  pathname: string;
  navigateTo: (path: string, options?: PlaygroundNavigateOptions) => void;
};

/**
 * Playground route state for App Router public paths
 * (`/playground`, `/{lang}/playground`, and legacy pilot bookmarks).
 */
export const usePlaygroundRoute = () => {
  const $ = _c(15);
  const pathname = usePathname();
  const params = useParams();
  const appRouter = useAppRouter();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = omitView => {
      const nextParams = new URLSearchParams(searchParams?.toString());
      if (omitView) {
        nextParams.delete("view");
      }
      const queryString = nextParams.toString();
      return queryString ? `?${queryString}` : "";
    };
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const buildAppQuerySuffix = t0;
  params?.slug;
  let t1;
  bb0: {
    let t2;
    if ($[2] !== pathname) {
      t2 = pathname ? parsePlaygroundPathname(pathname) : null;
      $[2] = pathname;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    const parsed = t2;
    if (!parsed) {
      t1 = null;
      break bb0;
    }
    const slugParam = params?.slug;
    let t3;
    if ($[4] !== parsed.slug || $[5] !== slugParam) {
      t3 = Array.isArray(slugParam) ? slugParam : typeof slugParam === "string" ? [slugParam] : parsed.slug;
      $[4] = parsed.slug;
      $[5] = slugParam;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    const slug = t3;
    let t4;
    if ($[7] !== appRouter || $[8] !== buildAppQuerySuffix) {
      t4 = (targetPath, options) => {
        const href = `${targetPath}${buildAppQuerySuffix(options?.omitView)}`;
        startTransition(() => {
          if (options?.replace) {
            appRouter.replace(href, {
              scroll: false
            });
            return;
          }
          appRouter.push(href, {
            scroll: false
          });
        });
      };
      $[7] = appRouter;
      $[8] = buildAppQuerySuffix;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    const navigateTo = t4;
    const t5 = pathname ?? parsed.basePath;
    let t6;
    if ($[10] !== navigateTo || $[11] !== parsed.basePath || $[12] !== slug || $[13] !== t5) {
      t6 = {
        basePath: parsed.basePath,
        slug,
        pathname: t5,
        navigateTo
      };
      $[10] = navigateTo;
      $[11] = parsed.basePath;
      $[12] = slug;
      $[13] = t5;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t1 = t6;
  }
  return t1;
};